module.exports = __webpack_public_path__ + "static/img/Opportunities_Visiting_Speakers_5.790f15e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Opportunities_Visiting_Speakers_5.jpg
// module id = pWHp
// module chunks = 1